<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import _ from "underscore";
import "./vender/underscore.mixin.js";
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 28px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue